import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';

const KEY = 'mygoal-pending-activity-reminder';
export default function ReminderNavigation() {
  const { isLoggedIn } = useUser();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(search);
    if (!isLoggedIn && pathname === '/agenda' && params.get('activity_id') && ['goal', 'rating'].includes(params.get('action'))) {
      sessionStorage.setItem(KEY, JSON.stringify({ search, expires: Date.now() + 30 * 60 * 1000 }));
    } else if (isLoggedIn && pathname === '/') {
      const saved = sessionStorage.getItem(KEY);
      sessionStorage.removeItem(KEY);
      try {
        const pending = JSON.parse(saved);
        if (pending?.expires > Date.now() && typeof pending.search === 'string' && pending.search.startsWith('?')) {
          navigate(`/agenda${pending.search}`, { replace: true });
        }
      } catch (_) { /* An expired or invalid link simply leaves the home page open. */ }
    } else if (isLoggedIn && pathname === '/agenda') {
      sessionStorage.removeItem(KEY);
    }
  }, [isLoggedIn, pathname, search, navigate]);
  return null;
}
